import { FBPixel } from 'modules/Types'

export const sortAlphabetically = (pixels: FBPixel[]) =>
  pixels.sort((a, b) => a.name.localeCompare(b.name, undefined, { sensitivity: 'base' }))
